import { Component, Input } from '@angular/core';
import { MatIconModule } from "@angular/material/icon";

@Component({
    selector: 'app-csv-download',
    imports: [MatIconModule],
    templateUrl: './csv-download.component.html',
    styleUrl: './csv-download.component.scss'
})
export class CsvDownloadComponent {
    @Input('data') data : any
    @Input('filename') filename : string = 'export.csv'


    exportToCsv(): void {
        const csvContent = this.convertToCsv(this.data);
        this.downloadCsv(csvContent, this.filename);
      }

    convertToCsv(data: any[], columns?: string[]): string {
        if (!data || data.length === 0) {
            return '';
        }

        const headers = columns || Object.keys(data[0]);
        let csv = headers.join(',') + '\n';

        data.forEach(row => {
            const rowValues = headers.map(header => {
                let value = row[header] !== undefined && row[header] !== null ? String(row[header]) : '';
                // Escape double quotes and enclose in double quotes if necessary
                if (value.includes(',') || value.includes('"') || value.includes('\n')) {
                    value = `"${value.replace(/"/g, '""')}"`;
                }
                return value;
            });
            csv += rowValues.join(',') + '\n';
        });

        return csv;
    }

    downloadCsv(csvString: string, filename: string): void {
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        // Programmatically click the link to trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href); // Clean up the URL object
    }
}
